import React from 'react';
import { ReactComponent as CartIcon } from 'common/icons/cart.svg';
import IconButton from 'common/components/IconButton';
import styled from '@emotion/styled';

type CartButtonProps = {
  setPageType: React.Dispatch<React.SetStateAction<string>>;
  itemCount?: number;
  type: string;
  active? : boolean;
};

const CartButtonIconWrapper = styled.div`
    height: 24px;
    width: 24px;
    display:flex;
    justify-content: center;
    align-items: center;
    position: relative;
`;

const CartCount = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.theme.colors.primaryColor};
    
`;

const CartText = styled.span`
    color: ${(props) => props.theme.colors.mainWhite};
    text-align: center;
    font-family: Mulish;
    font-size: 6px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%; /* 6px */
    letter-spacing: 1px;
    position:absolute;
    top: 50%;
    left: 50%;
    transform: translate(-41%, -52%);
`;

export default function CartButton({ setPageType, itemCount, type, active }: CartButtonProps) {
  return (
        <IconButton active={active} onClick={() => { setPageType(type); }}>
            <CartButtonIconWrapper>
                <CartIcon className='svg-black' />
                {itemCount !== 0 && <CartCount><CartText>{itemCount || 0}</CartText></CartCount>}
            </CartButtonIconWrapper>
        </IconButton>
  );
}